import { memo } from "react";
import cn from "classnames";
import { Text } from "../../../../packages/ui-kit";
import styles from "./message-kinds.module.scss";

type Props = {
  date: string;
  isScrolling?: boolean;
};

export const ServiceMessageDate = memo(
  ({ date, isScrolling = false }: Props) => {
    if (!date) {
      return null;
    }

    const className = cn(styles.date, {
      [styles.appearance]: isScrolling,
    });

    return (
      <div data-test-id="chat-message-date" className={className}>
        <Text
          size="xsmall"
          className={styles.text}
          dataTestId="chat-message-date-value"
        >
          {date}
        </Text>
      </div>
    );
  }
);
